/**
 * PDP v2 (spec 019), loaded by the v2 layout of main-product (inside
 * <product-form class="pdp-v2">), so also in quick buy and the preview panel.
 * §4.4: idempotent (soft navigation re-runs script[src]); no inline script,
 * config from JSON islands; elements re-read islands on connect and remove
 * their listeners on disconnect; analytics only via gtag, no personal data.
 * Pure helpers on theme.pdpV2 are what the Liquid mirrors (tests run them).
 */
(function () {
  'use strict';

  if (window.theme && window.theme.pdpV2 && window.theme.pdpV2.__initialised) return;
  var theme = window.theme = window.theme || {};
  var api = theme.pdpV2 = theme.pdpV2 || {};
  api.__initialised = true;

  // ---------------------------------------------------------------------------
  // Pure helpers (mirrors of the Liquid rules; no DOM)
  // ---------------------------------------------------------------------------

  var AU = { '2XS': 6, XS: 8, S: 10, M: 12, L: 14, XL: 16, '2XL': 18, '3XL': 20, '4XL': 22 };

  /** M3: strip a trailing " - {colour}" (case-insensitive, trimmed). */
  api.stripColourSuffix = function (title, colour) {
    var t = String(title == null ? '' : title);
    var c = String(colour == null ? '' : colour).trim();
    if (!c) return t;
    var suffix = ' - ' + c;
    if (t.length > suffix.length && t.slice(-suffix.length).toLowerCase() === suffix.toLowerCase()) {
      return t.slice(0, -suffix.length).trim();
    }
    return t;
  };

  /** M8: first clause of fit_consensus, 12-90 characters, else null. */
  api.fitLine = function (text) {
    var s = String(text == null ? '' : text);
    var cut = s.length;
    var semi = s.indexOf(';');
    var dot = s.indexOf('.');
    if (semi !== -1 && semi < cut) cut = semi;
    if (dot !== -1 && dot < cut) cut = dot;
    var out = s.slice(0, cut).trim();
    if (!out) return null;
    out = out.charAt(0).toUpperCase() + out.slice(1) + '.';
    return out.length >= 12 && out.length <= 90 ? out : null;
  };

  /**
   * ASCII letters and upper-case letters in a text (snippets/pdp-v2-letter-count
   * counts the same way, loop-free, so long text never meets a Liquid limit).
   */
  api.letterCounts = function (text) {
    var s = String(text || '');
    var letters = (s.match(/[A-Za-z]/g) || []).length;
    var upper = (s.match(/[A-Z]/g) || []).length;
    return { letters: letters, upper: upper };
  };

  /** M12: at least 20 letters, more than 60% upper-case. */
  api.isShouting = function (text) {
    var c = api.letterCounts(text);
    return c.letters >= 20 && c.upper * 10 > c.letters * 6;
  };

  /** M12: excerpt at the last sentence end within max, else null. */
  api.trimQuote = function (text, max) {
    var limit = max || 240;
    var chars = Array.from(String(text || ''));
    if (chars.length <= limit) return chars.join('');
    var head = chars.slice(0, limit);
    var end = -1;
    for (var i = 0; i < head.length; i++) {
      if (head[i] === '.' || head[i] === '!' || head[i] === '?') end = i;
    }
    if (end < 0) return null;
    return head.slice(0, end + 1).join('') + '…';
  };

  /** M12: first token of user_name when it holds at least 2 letters. */
  api.displayName = function (userName) {
    var first = String(userName || '').trim().split(/\s+/)[0] || '';
    return api.letterCounts(first).letters >= 2 ? first : '';
  };

  /** M12: integer rating 1-5, else null. */
  api.quoteStars = function (rating) {
    if (rating === null || rating === undefined || rating === '') return null;
    var n = Number(rating);
    return Number.isInteger(n) && n >= 1 && n <= 5 ? n : null;
  };

  /** M12: selection in metafield order; never edits a quote. */
  api.selectQuotes = function (entries, limit) {
    var max = limit || 3;
    var seen = {};
    var out = [];
    (entries || []).some(function (entry) {
      if (out.length >= max) return true;
      var e = entry || {};
      var review = String(e.review == null ? '' : e.review).trim();
      if (!review || Object.prototype.hasOwnProperty.call(seen, review)) return false;
      seen[review] = true;
      if (api.isShouting(review)) return false;
      var text = api.trimQuote(review, 240);
      if (!text) return false;
      out.push({ text: text, name: api.displayName(e.user_name), stars: api.quoteStars(e.rating) });
      return false;
    });
    return out;
  };

  /** M12 caption (D2). */
  api.quoteCaption = function (name, verifiedLabel) {
    if (name && verifiedLabel) return name + ' · ' + verifiedLabel;
    return name || verifiedLabel || '';
  };

  /** M2: "1,096 reviews" / "1 review". */
  api.formatCount = function (n) {
    return String(Math.max(0, Math.floor(Number(n) || 0))).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  api.reviewCountLabel = function (n) {
    return api.formatCount(n) + (Math.floor(Number(n) || 0) === 1 ? ' review' : ' reviews');
  };

  /** M7: short label -> AU size, or null. */
  api.auValue = function (shortLabel) {
    var k = String(shortLabel || '').trim().toUpperCase();
    return Object.prototype.hasOwnProperty.call(AU, k) ? AU[k] : null;
  };

  /** M7 legend value: " — M, AU 12" / " — M" / " — select". */
  api.legendValue = function (shortLabel, au) {
    if (!shortLabel) return ' — select';
    return ' — ' + shortLabel + (au ? ', AU ' + au : '');
  };

  // ---------------------------------------------------------------------------
  // DOM helpers
  // ---------------------------------------------------------------------------

  api.isInjected = function (el) {
    return !!(el && el.closest && el.closest('product-preview-panel, .quickbuy-container'));
  };

  api.readIsland = function (root, selector) {
    var el = root && root.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  };

  api.track = function (name, params) {
    if (typeof window.gtag !== 'function') return false;
    try {
      window.gtag('event', name, params || {});
      return true;
    } catch (err) {
      return false;
    }
  };

  /**
   * §9 pdp_add source from an on:cart:add target (020-F3):
   *   - the v2 main form itself -> 'pdp_main' (never an injected copy);
   *   - a <sticky-atc> whose .section-main-product holds a v2 main form -> 'sticky'.
   */
  api.pdpAddSource = function (target) {
    if (!target || !target.matches) return null;
    if (target.matches('product-form.pdp-v2')) {
      return api.isInjected(target) ? null : 'pdp_main';
    }
    if (target.matches('sticky-atc')) {
      var section = target.closest('.section-main-product');
      if (section && section.querySelector('product-form.pdp-v2')) return 'sticky';
    }
    return null;
  };

  /** The main v2 form a pdp_add source refers to. */
  function mainFormFor(target) {
    if (target.matches('product-form.pdp-v2')) return target;
    var section = target.closest('.section-main-product');
    return section ? section.querySelector('product-form.pdp-v2') : null;
  }

  function variantFor(form, variantId) {
    var picker = form && form.querySelector('variant-picker');
    if (!picker || typeof picker.getVariantData !== 'function') return null;
    var data = picker.getVariantData() || {};
    var id = Number(variantId);
    return (data.variants || []).find(function (v) { return Number(v.id) === id; }) || null;
  }

  function configFor(form) {
    return api.readIsland(form, 'script[data-pdp-v2-config]') || {};
  }

  /** M2/M12: where "#reviews" should land before S3 builds its own section. */
  api.resolveReviewsTarget = function (doc) {
    var d = doc || document;
    return d.getElementById('reviews')
      || d.querySelector('[id*="17125831381d028ade"]')
      || d.querySelector('[data-oke-widget]')
      || d.querySelector('.review-summary')
      || null;
  };

  // ---------------------------------------------------------------------------
  // Document listeners (installed once per document, by the guard above)
  // ---------------------------------------------------------------------------

  document.addEventListener('on:cart:add', function (evt) {
    var target = evt.target;
    var source = api.pdpAddSource(target);
    if (!source) return;
    var form = mainFormFor(target);
    var config = configFor(form);
    var variant = variantFor(form, evt.detail && evt.detail.variantId);
    var params = { source: source, items_count: 1, currency: config.currency || undefined };
    if (variant && typeof variant.price === 'number') params.value = variant.price / 100;
    api.track('pdp_add', params);
    // §10 (S4): the theme opens the drawer after a main add without an opener,
    // so closing it drops focus to <body>. Remember this add button and hand
    // focus back on close; v2 forms only, main.js untouched.
    lastAddButton = target.querySelector('[name="add"]');
  });

  var lastAddButton = null;
  document.addEventListener('on:cart-drawer:after-close', function (evt) {
    var btn = lastAddButton;
    lastAddButton = null;
    // At after-close, focus is still on a control inside the now-hidden drawer
    // (it falls to <body> later), or already on <body>.
    var active = document.activeElement;
    var drawer = evt.target && evt.target.contains ? evt.target : null;
    var lost = !active || active === document.body || (drawer && drawer.contains(active));
    var visible = function (el) { return !!(el && el.isConnected && el.getClientRects().length); };
    var setAdd = api.mutation && api.mutation.returnFocus;
    if (api.mutation) api.mutation.returnFocus = false;
    if (!lost) return;
    if (visible(btn)) { btn.focus({ preventScroll: true }); return; }
    // After a confirmed set add the row resets (§8.5), hiding the set button the
    // drawer tried to return to: use it if visible, else the first visible tile.
    var row = setAdd ? document.querySelector('.section-main-product pdp-set-row') : null;
    if (!row) return;
    var cta = row.querySelector('[data-cta]');
    var tile = Array.prototype.find.call(row.querySelectorAll('.pdp-v2-set__tile'), visible);
    var target = visible(cta) ? cta : tile;
    if (target) target.focus({ preventScroll: true });
  });

  // Bring el near the top, clear of the sticky header (instant under reduced motion).
  function nearTop(el) {
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var header = typeof theme.stickyHeaderHeight === 'function' ? theme.stickyHeaderHeight() : 0;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - header - 24, behavior: reduce ? 'auto' : 'smooth' });
  }

  api.nearTop = nearTop;

  // Mat, S3 UAT: "Read the policy" opens the Returns accordion in place (the
  // href is the fallback). The set row's "See all" is pdp-v2-see-all.js.
  document.addEventListener('click', function (evt) {
    var t = evt.target && evt.target.closest ? evt.target : null;
    var link = t && t.closest('[data-pdp-v2-returns-link]');
    if (!link || api.isInjected(link)) return;
    var form = link.closest('product-form');
    var dd = form && Array.prototype.find.call(form.querySelectorAll('details-disclosure'), function (d) {
      var s = d.querySelector('summary');
      return s && /return/i.test(s.textContent);
    });
    if (!dd) return;
    evt.preventDefault();
    var details = dd.querySelector('details');
    if (details && !details.open) {
      if (typeof dd.open === 'function') dd.open(); else details.open = true;
    }
    var summary = dd.querySelector('summary');
    // The heading near the top, so the opened policy is readable above the sticky bar.
    nearTop(dd);
    if (summary) summary.focus({ preventScroll: true });
  });

  // One pending reviews-link correction sequence per document (see below).
  var reviewsScroll = null;
  var SCROLL_STOPPERS = ['wheel', 'touchstart', 'keydown'];
  function cancelReviewsScroll() {
    var seq = reviewsScroll;
    if (!seq) return;
    reviewsScroll = null;
    clearTimeout(seq.timer);
    SCROLL_STOPPERS.forEach(function (t) { window.removeEventListener(t, seq.stop, { capture: true }); });
  }
  api.cancelReviewsScroll = cancelReviewsScroll;

  document.addEventListener('click', function (evt) {
    var link = evt.target && evt.target.closest ? evt.target.closest('[data-pdp-v2-reviews-link]') : null;
    if (!link || api.isInjected(link)) return;
    var target = api.resolveReviewsTarget(document);
    if (!target) return;
    evt.preventDefault();
    cancelReviewsScroll();
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var drift = function () {
      var header = typeof theme.stickyHeaderHeight === 'function' ? theme.stickyHeaderHeight() : 0;
      return target.getBoundingClientRect().top - (100 + header);
    };
    if (reduce) {
      window.scrollBy({ top: drift(), behavior: 'auto' }); // §10: no motion
    } else if (typeof theme.scrollToRevealElement === 'function') {
      theme.scrollToRevealElement(target);
    } else {
      target.scrollIntoView();
    }
    // Sections above (the offer grid, testimonials, lazy media) can still be
    // growing while the scroll runs, which leaves #reviews low on the screen.
    // Re-check after the layout settles, at most three corrections, and stop
    // as soon as the shopper scrolls or types, another click starts, or the
    // target is no longer this page's reviews section (e.g. after a soft
    // navigation replaced it).
    var seq = { tries: 0, timer: null };
    seq.stop = function () { if (reviewsScroll === seq) cancelReviewsScroll(); };
    reviewsScroll = seq;
    SCROLL_STOPPERS.forEach(function (t) { window.addEventListener(t, seq.stop, { capture: true, passive: true }); });
    var tick = function () {
      seq.timer = setTimeout(function () {
        if (reviewsScroll !== seq) return;
        if (!target.isConnected || api.resolveReviewsTarget(document) !== target) { cancelReviewsScroll(); return; }
        var d = drift();
        if (Math.abs(d) > 60 && seq.tries < 3) {
          seq.tries += 1;
          window.scrollBy({ top: d, behavior: reduce ? 'auto' : 'smooth' });
          tick();
        } else {
          cancelReviewsScroll();
        }
      }, 700);
    };
    tick();
  });

  // ---------------------------------------------------------------------------
  // <pdp-v2-page>: rendered once inside each v2 <product-form>
  // ---------------------------------------------------------------------------

  function checkedShortLabel(fieldset) {
    var input = fieldset.querySelector('input[type="radio"]:checked');
    if (!input) return { label: '', au: null };
    var label = input.nextElementSibling;
    var valueEl = label && label.querySelector('.js-value');
    var auEl = label && label.querySelector('[data-au]');
    return {
      label: valueEl ? valueEl.textContent.trim() : input.value,
      au: auEl ? auEl.getAttribute('data-au') : null
    };
  }

  function updateLegends(form) {
    form.querySelectorAll('fieldset.option-selector').forEach(function (fieldset) {
      var slot = fieldset.querySelector('[data-legend-value]');
      if (!slot) return;
      var picked = checkedShortLabel(fieldset);
      var text = api.legendValue(picked.label, picked.au);
      if (slot.textContent !== text) slot.textContent = text;
    });
  }

  // Compact mobile sticky bar (Mat, 2026-09-29): a size button opens the bar's
  // chips (sticky-atc.js applies the choice), then "Size M" + Add to bag; CSS
  // lays it out below 768px. While shown, <html> carries .pdp-v2-sticky-in and
  // --pdp-v2-sticky-h for the chat launcher. Returns a teardown, or null.

  var stickySeq = 0;
  function mountStickyBar(form, sticky) {
    var options = sticky.querySelector('.sticky-atc__options');
    var buttons = sticky.querySelector('.sticky-atc__buttons');
    var name = options && options.getAttribute('data-option');
    var fieldset = name && Array.prototype.find.call(form.querySelectorAll('fieldset.option-selector'), function (f) { return f.getAttribute('data-option') === name; });
    if (!fieldset || !buttons) return null;
    // A restored snapshot may carry a size button from before: start clean.
    Array.prototype.forEach.call(sticky.querySelectorAll('.pdp-v2-sticky-size'), function (el) { el.remove(); });
    if (!options.id) options.id = 'pdp-v2-sticky-sizes-' + (++stickySeq);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pdp-v2-sticky-size';
    btn.setAttribute('aria-controls', options.id);
    // After the set link when it is already there (pdp-v2-set.js puts a later
    // one before this button), so tab order matches the visual order.
    buttons.parentNode.insertBefore(btn, buttons);
    var root = document.documentElement;

    function isOpen() { return sticky.classList.contains('pdp-v2-sticky--sizes-open'); }
    function onOutside(evt) { if (!sticky.contains(evt.target)) setOpen(false); }
    function setOpen(open) {
      sticky.classList.toggle('pdp-v2-sticky--sizes-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) document.addEventListener('pointerdown', onOutside, true);
      else document.removeEventListener('pointerdown', onOutside, true);
    }
    function sync() {
      var picked = checkedShortLabel(fieldset);
      sticky.classList.toggle('pdp-v2-sticky--has-size', !!picked.label);
      btn.textContent = picked.label ? name + ' ' + picked.label : 'Choose your ' + name.toLowerCase();
    }
    function lift() {
      var shown = !sticky.classList.contains('sticky-atc--out') && !document.body.classList.contains('scrolled-to-bottom') && sticky.getClientRects().length > 0;
      if (!shown && isOpen()) setOpen(false);
      root.classList.toggle('pdp-v2-sticky-in', shown);
      if (shown) root.style.setProperty('--pdp-v2-sticky-h', sticky.offsetHeight + 'px');
    }
    function onClick(evt) {
      var target = evt.target;
      if (btn.contains(target)) {
        setOpen(!isOpen());
        var chip = isOpen() && (options.querySelector('.sticky-atc__option.is-selected') || options.querySelector('.sticky-atc__option:not(.is-unavailable):not(.is-nonexistent)'));
        if (chip) chip.focus({ preventScroll: true });
        return;
      }
      // Bubble phase: sticky-atc.js (on the chips' container) has already
      // checked the main radio, and the variant change ran synchronously.
      if (!isOpen() || !target.closest || !target.closest('.sticky-atc__option')) return;
      sync();
      setOpen(false);
      var add = buttons.querySelector('.add-to-cart');
      if (add && !add.disabled && add.getClientRects().length) add.focus({ preventScroll: true });
      else btn.focus({ preventScroll: true });
    }
    function onKey(evt) {
      if (evt.key !== 'Escape' || !isOpen()) return;
      setOpen(false);
      btn.focus({ preventScroll: true });
    }

    sticky.classList.add('pdp-v2-sticky');
    setOpen(false);
    sync();
    form.addEventListener('on:variant:change', sync);
    sticky.addEventListener('click', onClick);
    sticky.addEventListener('keydown', onKey);
    var observer = new MutationObserver(lift);
    observer.observe(sticky, { attributes: true, attributeFilter: ['class'] });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var resize = typeof ResizeObserver === 'function' ? new ResizeObserver(lift) : null;
    if (resize) resize.observe(sticky);
    lift();

    return function () {
      setOpen(false);
      observer.disconnect();
      if (resize) resize.disconnect();
      form.removeEventListener('on:variant:change', sync);
      sticky.removeEventListener('click', onClick);
      sticky.removeEventListener('keydown', onKey);
      btn.remove();
      sticky.classList.remove('pdp-v2-sticky', 'pdp-v2-sticky--has-size', 'pdp-v2-sticky--sizes-open');
      root.classList.remove('pdp-v2-sticky-in');
      root.style.removeProperty('--pdp-v2-sticky-h');
    };
  }
  api.mountStickyBar = mountStickyBar;

  class PdpV2Page extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.form = this.closest('product-form');
      if (!this.form) return;
      this.injected = api.isInjected(this);
      if (this.injected) this.form.classList.add('is-injected');
      this.config = api.readIsland(this.form, 'script[data-pdp-v2-config]') || {};

      this._onVariantChange = function () { updateLegends(this.form); }.bind(this);
      this._onChange = this.handleChange.bind(this);
      this.form.addEventListener('on:variant:change', this._onVariantChange);
      this.form.addEventListener('change', this._onChange);
      updateLegends(this.form);
      // §10 (S4 axe): the theme's gallery "show gallery" links have no name.
      var shows = this.form.querySelectorAll('a.show-gallery');
      Array.prototype.forEach.call(shows, function (link, i) {
        if (!link.getAttribute('aria-label') && !link.textContent.trim()) link.setAttribute('aria-label', 'Open image ' + (i + 1) + ' of ' + shows.length);
      });

      // 024-F4: a sticky size chip is a real user choice, but the bar applies it
      // by checking the main radio and dispatching a synthetic 'change'
      // (sticky-atc.js onOptionClick). Remember the trusted chip click so that
      // one bridged change counts; other programmatic changes still do not.
      var section = this.form.closest('.section-main-product');
      this.sticky = !this.injected && section ? section.querySelector('sticky-atc') : null;
      this._stickyIntent = null;
      this._onStickyClick = function (evt) {
        var chip = evt.isTrusted && evt.target.closest ? evt.target.closest('.sticky-atc__option') : null;
        if (chip) this._stickyIntent = { value: chip.getAttribute('data-value'), at: Date.now() };
      }.bind(this);
      if (this.sticky) this.sticky.addEventListener('click', this._onStickyClick, true);
      this._unmountSticky = this.sticky ? mountStickyBar(this.form, this.sticky) : null;

      if (!this.injected && this.config.productId) {
        api.track('pdp_v2_view', { product_id: String(this.config.productId) });
      }
    }

    disconnectedCallback() {
      if (!this._connected) return;
      this._connected = false;
      if (this.form) {
        this.form.removeEventListener('on:variant:change', this._onVariantChange);
        this.form.removeEventListener('change', this._onChange);
      }
      if (this.sticky) this.sticky.removeEventListener('click', this._onStickyClick, true);
      if (this._unmountSticky) this._unmountSticky();
      this._unmountSticky = null;
      this._stickyIntent = null;
    }

    handleChange(evt) {
      var input = evt.target;
      if (this.injected || !input || input.type !== 'radio') return;
      var userChoice = evt.isTrusted;
      var intent = this._stickyIntent;
      if (!userChoice && intent && Date.now() - intent.at < 1000 && input.value === intent.value) {
        userChoice = true;
        this._stickyIntent = null;
      }
      if (!userChoice) return;
      var fieldset = input.closest('fieldset.option-selector');
      if (!fieldset || !fieldset.querySelector('[data-legend-value]')) return;
      var picked = checkedShortLabel(fieldset);
      if (!picked.label) return;
      api.track('size_select', { product_id: String(this.config.productId || ''), size: picked.label });
    }
  }

  // ---------------------------------------------------------------------------
  // <pdp-curated-review>: manual pager, no autoplay (M12)
  // ---------------------------------------------------------------------------

  class PdpCuratedReview extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      // A restored snapshot may have been serialised mid-page: always reset.
      this.quotes = Array.prototype.slice.call(this.querySelectorAll('.pdp-v2-quote'));
      this.total = this.quotes.length;
      this.index = 0;
      this.render(false);
      if (api.isInjected(this)) {
        this.classList.add('is-injected');
        return;
      }
      this._onClick = this.handleClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (!this._connected) return;
      this._connected = false;
      if (this._onClick) this.removeEventListener('click', this._onClick);
    }

    handleClick(evt) {
      var btn = evt.target.closest ? evt.target.closest('[data-pager]') : null;
      if (!btn || this.total < 2) return;
      var step = btn.getAttribute('data-pager') === 'prev' ? -1 : 1;
      this.index = (this.index + step + this.total) % this.total;
      this.render(true);
      api.track('curated_review_next', { position: this.index + 1 });
    }

    render(announce) {
      var i = this.index;
      this.quotes.forEach(function (q, n) { q.hidden = n !== i; });
      var pos = this.querySelector('[data-position]');
      if (pos) pos.textContent = (i + 1) + ' / ' + this.total;
      var live = this.querySelector('[data-live]');
      if (live) {
        var template = this.getAttribute('data-announce') || 'Review {n} of {total}';
        live.textContent = announce
          ? template.replace('{n}', String(i + 1)).replace('{total}', String(this.total))
          : '';
      }
    }
  }

  // ---------------------------------------------------------------------------
  // <pdp-v2-faq>: M18 accordions (button[aria-expanded], §10) and Show more.
  // State lives in the attributes, so a restored snapshot stays consistent.
  // ---------------------------------------------------------------------------

  class PdpV2Faq extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._onClick = this.handleClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (!this._connected) return;
      this._connected = false;
      this.removeEventListener('click', this._onClick);
    }

    handleClick(evt) {
      var t = evt.target && evt.target.closest ? evt.target : null;
      if (!t) return;
      var more = t.closest('[data-faq-more]');
      if (more) {
        var open = more.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('[data-faq-extra]').forEach(function (item) { item.hidden = !open; });
        more.setAttribute('aria-expanded', String(open));
        more.textContent = open ? (more.getAttribute('data-less-label') || 'Show less') : (more.getAttribute('data-more-label') || 'Show more');
        if (open) {
          var first = this.querySelector('[data-faq-extra] button[aria-controls]');
          if (first) first.focus();
        }
        return;
      }
      var btn = t.closest('button[aria-controls]');
      if (!btn || !this.contains(btn)) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    }
  }

  // M6: length_select when a length link is followed (dormant until E1).
  document.addEventListener('click', function (evt) {
    var link = evt.target && evt.target.closest ? evt.target.closest('[data-pdp-v2-length]') : null;
    if (!link || link.getAttribute('aria-current') === 'page') return;
    api.track('length_select', {
      from_pattern: link.getAttribute('data-from-pattern') || '',
      to_pattern: link.getAttribute('data-to-pattern') || ''
    });
  });

  if (!customElements.get('pdp-v2-page')) customElements.define('pdp-v2-page', PdpV2Page);
  if (!customElements.get('pdp-curated-review')) customElements.define('pdp-curated-review', PdpCuratedReview);
  if (!customElements.get('pdp-v2-faq')) customElements.define('pdp-v2-faq', PdpV2Faq);
})();
